var _circle, _g, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpaca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#FFD700"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1a1a1a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 170,
    rx: 55,
    ry: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 145 Q 100 110 110 75 L 138 70 Q 145 105 148 145 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124,
    cy: 65,
    rx: 22,
    ry: 28
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124,
    cy: 80,
    rx: 14,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 110 42 L 105 22 L 118 38 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 138 42 L 143 22 L 130 38 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 195,
    width: 10,
    height: 40,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 195,
    width: 10,
    height: 40,
    rx: 3
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 58,
    r: 3,
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpaca);
export default __webpack_public_path__ + "static/media/alpaca.f05345965b9ef4d63cb839077ab9dcfe.svg";
export { ForwardRef as ReactComponent };